/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-template */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CONTROL_ACTIONMODE } from '../../Constants';
import { ArticleDocuments } from '../../manager/interface/APIManager';
import FileUtil from '../../util/FileUtil';

/**
 * フリーキャラクターテキストアイテム入力dilaogクラス
 */
export default class PlanDocumentListDialog extends Dialog {
  public docList: ArticleDocuments[] = [];

  public selectedDoc = [];

  /**
    * コンストラクタ
  */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean) {
    super(draggable);
  }

  /**
   *  内容の追加
   */
  buildContent() {
    let id: string;
    let title: string;
    let contents: string;
    let footer: string;
    // ダイアログのコンテンツ生成
    id = 'planDocumentListDialog';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'ドキュメント リスト'; break;
      default: title = 'Document list'; break;
    }

    contents = '<div class="dialogPlanDocumentList">\n';
    contents += '<div class="dialogBodyInner">\n';
    contents += '<div class="docListContainer">\n';
    contents += '<table class="docListTable">\n';
    contents += '<thead>\n';
    contents += '<tr><th></th><th>カテゴリー</th><th>ファイル名</th></tr>\n';
    contents += '</thead>\n';
    contents += '<tbody>\n';
    for (let i = 0; i < this.docList.length; i += 1) {
      contents += `<tr data-index="${i}" class="document_list_row">`;
      // パスから写真と判断した場合、写真を表示/それ以外は空とする ph6対応（カテゴリをサイトで変更できる機能により）
      if (FileUtil.isImageFile(this.docList[i].file_path)) {
        contents += `<td><img src='${this.docList[i].file_path}' /></td>`;
      } else {
        contents += '<td></td>';
      }
      contents += `<td>${this.docList[i].category}</td><td>${this.docList[i].display_name}</td>`;
      contents += '</tr>\n';
    }
    contents += '</tbody>\n';
    contents += '</div>\n';
    contents += '</div>\n';
    contents += '<div class="error_msg"></div>\n';
    contents += '</div>\n';
    contents += '</div>';
    footer = '<button id="btnDone"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    this.createDialog(id, title, contents, footer);

    // お掃除
    id = null;
    title = null;
    contents = null;
    footer = null;
    if (document.getElementById('btnCancel')) {
      document.getElementById('btnCancel').onclick = (e: Event) => {
        this.btnCancelHandler(e);
      };
    }
    if (document.getElementById('btnDone')) {
      document.getElementById('btnDone').onclick = (e: Event) => this.btnDoneHandler(e);
    }
    const elements = document.querySelectorAll('.dialogPlanDocumentList .document_list_row');
    for (let i = 0; i < elements.length; i += 1) {
      elements[i].addEventListener('click', this.handleSelection, false);
    }
  }

  /**
   * リスト選択時
   */
  handleSelection= (e:MouseEvent & TouchEvent) => {
    this.selectedDoc = [];
    // 選択されている行を解除
    $('.dialogPlanDocumentList .document_list_row').removeClass('selected');
    // 選択された行をハイライト
    const target = <HTMLElement>e.currentTarget;
    target.classList.add('selected');
    const index = target.getAttribute('data-index');
    this.selectedDoc.push(this.docList[index]);
  }

  // getcategoryName(id: number) {
  //   let name = '';
  //   switch (id) {
  //     case 1:
  //       name = '図面';
  //       break;
  //     case 2:
  //       name = '写真';
  //       break;
  //     case 3:
  //       name = '見積り';
  //       break;
  //     case 4:
  //       name = '仕様書';
  //       break;
  //     default:
  //       break;
  //   }
  //   return name;
  // }

  /**
   * OKボタンがクリックされた
   * @return void
   * @param e => mouse event
  */
  btnDoneHandler = (e: any) => {
    if (this.selectedDoc.length === 0) {
      marietta.webcad.WebCADGlobal.showAlert('ドキュメントを選択してください');
      return;
    }
    e.preventDefault();
    if (this.callBack) {
      this.callBack(this.selectedDoc);
    }
    this.closeEvent();
  }

  /**
   * Cancelボタンがクリックされた
   * @return void
   * @param e => mouse event
  */
  btnCancelHandler = (e: any) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    // パネルを閉じる
    this.close();
  }

  /**
  * 閉じるボタンが押された
  */
  close = () => {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    this.closeEvent();
  }
}
